import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: []
};

const getters = {
  isLoading: (state) => state.status === "loading",
  list_to_select: (state) =>
    formatArrayToElSelect(state.list, {
      label: "FullName",
      value: "Code"
    }),
  listContact: (state) =>
    formatArrayToElSelect(state.list, {
      label: "FullName",
      value: "Code"
    })
};

const actions = {
  getByCustomerCode: ({ commit, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const { customerCode = undefined } = payload;

      api
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  getByProspectCode: ({ commit, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const { contactCode = undefined } = payload;

      api
        .get("/api/contacts/GetContactByProspect", {
          params: {
            contactCode: contactCode,
            companyCode: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.state = "error";
  },
  list: (state, data) => {
    state.list = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
